<template>
<div id="tencentdoc"></div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { loadMicroApp, initGlobalState } from "qiankun";
import Cookies from "js-cookie";
import mitt from "mitt";
import { mapState, mapActions } from "vuex";
import { getToken, getUserId, getSpaceId, getDeviceId } from "../utils/userInfoUtil";

const microAppName = "tencentdoc.excel";

export default {
  name: "test_vue",
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    fileId: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    belongingFileId: {
      type: String,
      default: ""
    },
    contentType: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      bus: null,
      microApp: null
    };
  },
  computed: {
    ...mapState({
      cloudI18n: (state) => state.cloudI18n
    })
  },
  methods: {
    ...mapActions([
    "addDownloadIds"]
    ),
    handleHistory() {
      this.bus.emit("showVersionList");
    },
    handlePrint() {
      this.bus.emit("print");
    },
    async handleSave() {
      return await this.bus.emit("saveVersion");
    },
    async handleExport(type) {
      if (type === "image") {
        this.bus.emit("exportPicture");
      } else if (type === "pdf") {
        try {
          const requestPath = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/create/${this.fileId}`;
          const response = await fetch(requestPath, {
            method: 'POST',
            headers: {
              DeviceType: '3',
              'Content-Type': 'application/json',
              token: getToken(this.showtype) || "",
              userId: getUserId(this.showtype) || "",
              spaceId: getSpaceId(this.showtype) || "",
              deviceId: getDeviceId(this.showtype) || ""
            },
            body: JSON.stringify({
              exportFormat: 'PDF'
            })
          });
          if (!response.ok) {
            this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/components/TencentOfficeView.vue_1"));
            return;
          }

          const data = await response.json();
          if (data.code !== 200) this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/components/TencentOfficeView.vue_2"));
          this.addDownloadIds(this.fileId);
        } catch (error) {
          this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/components/TencentOfficeView.vue_3"));
        }
      }
    },
    addTencentDocClass() {
      const fileContainer = document.querySelector(".file-container");
      fileContainer.classList.add('tencent-doc-sheet');
      const isSupportWatermark =
      this.contentType === 'WORD' ||
      this.contentType === 'PPT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'TXT' ||
      this.contentType === 'PDF';

      if (!isSupportWatermark) {
        this.removeTencentDocClass();
      }
    },
    removeTencentDocClass() {
      const fileContainer = document.querySelector(".file-container");
      fileContainer.classList.remove('tencent-doc-sheet');
    }
  },
  mounted() {
    this.bus = mitt();
    this.bus?.on('tencentLoadError', (retcode) => {
      if (retcode === 402703) {
        this.$emit('handleGoDownload');
      }
    });
    const actions = initGlobalState({});
    let propsMap = {
      actions,
      userInfo: {
        ...this.userInfo,
        token: Cookies.get("token") || ""
      },
      fileId: this.fileId,
      bus: this.bus,
      language: this.cloudI18n,
      envPath: process.env.VUE_APP_BASE_URL,
      propsDocsConfig: {
        toolbar: !this.isPreview
      },
      uiService: {
        message: this.$message
      }
    };
    //处理预览逻辑，强制只读
    if (this.isPreview === true) {
      propsMap = {
        ...propsMap,
        readonly: this.isPreview
      };
    }
    //处理附件预览逻辑
    if (this.belongingFileId && this.belongingFileId.length > 0) {
      propsMap = {
        ...propsMap,
        belongingFileId: this.belongingFileId
      };
    }

    this.microApp = loadMicroApp({
      name: microAppName,
      entry: "https://m.elongstatic.com/toca_tencent_doc/0.4.3/index.html",
      //   entry: "http://10.161.120.54:8081/",
      container: "#tencentdoc",
      activeRule: () => true,
      props: propsMap
    });
    // 腾讯表格隐藏管家水印
    this.addTencentDocClass();

    // 处理预览or下载逻辑
    const isWps =
    this.contentType === 'WORD' ||
    this.contentType === 'PPT' ||
    this.contentType === 'PDF' ||
    this.contentType === 'EXCEL';

    if (!isWps) {
      if (this.size > 100 * 1024 * 1024) {
        this.$emit("handleGoDownload");
      }
    }
  },
  beforeDestroy() {
    this.bus?.off('tencentLoadError');
    this.bus = null;
    if (this.microApp && this.microApp.unmount) {
      this.microApp.unmount();
      this.microApp = null;
    }
    this.removeTencentDocClass();
  }
};
</script>

<style lang="scss" scoped>
#tencentdoc {
  width: 100%;
  height: 100%;
}
</style>

<style>
.tencent-doc-sheet #water-mark-cloud {
  opacity: 0 !important;
}
</style>
